module.exports = __webpack_public_path__ + "static/media/hiddenmagnets.3be92723.jpg";